import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
// Init i18n BEFORE any components use useTranslation
import './i18n';
import './components/ModalOptimization.css';
import App from './App';
import DriverWebApp from './components/DriverWebApp';
import PublicTracking from './components/PublicTracking';
import PublicCustomerApp from './components/PublicCustomerApp';

const TAXINU_ROUTE_NULL_DEBUG_URL = 'http://127.0.0.1:7779/event';
const TAXINU_ROUTE_NULL_SESSION = 'taxinu-route-null';
const TAXINU_ROUTE_NULL_MARKER = 'index-live-20260913a';
const canUseLocalTaxinuRouteNullDebug = typeof window !== 'undefined' && ['127.0.0.1', 'localhost'].includes(window.location.hostname);
const reportTaxinuRouteNullDebug = (hypothesisId, location, msg, data = {}) => {
  if (!canUseLocalTaxinuRouteNullDebug) {
    return Promise.resolve();
  }

  return fetch(TAXINU_ROUTE_NULL_DEBUG_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      sessionId: TAXINU_ROUTE_NULL_SESSION,
      runId: 'pre-fix',
      hypothesisId,
      location,
      msg,
      data,
      ts: Date.now()
    })
  }).catch(() => {});
};

axios.defaults.timeout = 15000;

// #region debug-point E:index-boot
reportTaxinuRouteNullDebug('E', 'index.js:boot', '[DEBUG] index.js boot reached', {
  marker: TAXINU_ROUTE_NULL_MARKER,
  pathname: window.location.pathname,
  href: window.location.href
});
window.addEventListener('error', (event) => {
  reportTaxinuRouteNullDebug('E', 'index.js:error', '[DEBUG] window error', {
    marker: TAXINU_ROUTE_NULL_MARKER,
    message: event?.message || null,
    filename: event?.filename || null,
    lineno: event?.lineno || null,
    colno: event?.colno || null
  });
});
window.addEventListener('unhandledrejection', (event) => {
  reportTaxinuRouteNullDebug('E', 'index.js:unhandledrejection', '[DEBUG] window unhandledrejection', {
    marker: TAXINU_ROUTE_NULL_MARKER,
    reason: event?.reason?.message || String(event?.reason || '')
  });
});
// #endregion

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/driver" element={<DriverWebApp />} />
        <Route path="/driver-app" element={<DriverWebApp />} />
        <Route path="/customer-app" element={<PublicCustomerApp />} />
        <Route path="/track" element={<PublicTracking />} />
        <Route path="/track/:trackingNumber" element={<PublicTracking />} />
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
